import copy from './websiteCopy.json';

export { copy };
export const displayTitle = text => text.toLowerCase().replace(/\b[a-z]/g, c => c.toUpperCase()).replace(/7d/g, '7D').replace(/Gee/g, 'GEE');

const media = {
  cinema: '/media/company/cinema.webp',
  immersive: '/media/company/immersive.webp',
  family: '/media/company/family.webp',
  culture: '/media/cultural-shows.webp',
  destination: '/media/bharat-hero.webp',
};

export const FLAGSHIP = {
  id: '7d-cinema-guptar-ghat', title: copy.flagship.title, image: media.cinema,
  category: 'Our flagship experience', note: 'Guptar Ghat, Ayodhya',
  description: copy.flagship.paragraphs.join(' '), location: 'Guptar Ghat, Ayodhya',
  tags: ['7D Cinema', '3D effects', 'Motion', 'Sensory elements'], icon: 'film',
  imageCaption: 'Illustrative cinema imagery',
};
const SERVICE_MEDIA = [media.immersive, media.cinema, media.culture, media.destination, media.family];
const SERVICE_IDS = ['immersive-attractions', 'immersive-cinema', 'cultural-experiences', 'experience-destinations', 'family-entertainment'];
const SERVICE_ICONS = ['sparkles', 'film', 'drama', 'landmark', 'people'];
export const SERVICES = copy.services.items.map((item, i) => ({
  ...item, id: SERVICE_IDS[i], image: SERVICE_MEDIA[i], icon: SERVICE_ICONS[i],
  category: 'What we do', note: item.description, imageCaption: 'Illustrative experience imagery',
}));
export const CATALOGUE = [FLAGSHIP, ...SERVICES];
export const ENQUIRY_INTERESTS = [FLAGSHIP.title, ...SERVICES.map(item => item.title), 'Partnership', 'General enquiry'];